<div class="app-email-thread-preview bc-work-item-theme {{ emailThreadThemeClass }}">
  <ng-container *ngIf="emailThread && lastEmail">
    <app-visitor-history
      [emailThreadId]="emailThread.id"
      [emailId]="lastEmail.id">
    </app-visitor-history>
    <app-email-viewer
      *ngIf="lastEmail"
      class="bc-panel"
      [email]="lastEmail">
    </app-email-viewer>
  </ng-container>
  <app-loading *ngIf="!lastEmail || !emailThread"></app-loading>
</div>
